function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//---- Automatically generated, don't update this part ----
/**
 * Describes a prescriptor
 */

export default class Prescriptor {
  constructor(params) {
    _defineProperty(this, "firstName", void 0);
    _defineProperty(this, "lastName", void 0);
    _defineProperty(this, "identifier", void 0);
    _defineProperty(this, "specialty", void 0);
    this.firstName = params.firstName;
    this.lastName = params.lastName;
    this.identifier = params.identifier;
    this.specialty = params.specialty;
  }
  toJson() {
    return {
      firstName: this.firstName,
      lastName: this.lastName,
      identifier: this.identifier,
      specialty: this.specialty
    };
  }

  //---- End of generated code ----
}